var React = require('react');

function AddUser (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4 8c0-4.4 3.6-8 8-8s8 3.6 8 8c0 3-1.5 5.4-3.7 6.8 4 1.5 6.8 5 7.5 9.2h-2c-1-4.6-5-8-9.8-8-5.5 0-10 4.5-10 10H0c0-5 3.2-9.5 7.7-11.2C5.5 13.4 4 10.8 4 8zm8 6c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6zm20 12v2h-4v4h-2v-4h-4v-2h4v-4h2v4h4z","fillRule":"evenodd"}));
}

AddUser.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = AddUser;

AddUser.default = AddUser;
